import { Link } from "react-router-dom";

const opening = "SURVIVE THE WASTELAND — ";
const middle = " — ";
const closing = " — READ THE SIGNAL — BUILD THE DECK — UNLOCK THE ARCHIVE — ";

function TickerHalf({ half }) {
  return Array.from({ length: 4 }, (_, i) => (
    <span key={i}>
      {opening}
      <Link to="/wasteland-run" className="marquee-play-link" data-testid={`marquee-play-link-${half}-${i}`}>
        PLAY DOLO'S WASTELAND RUN
      </Link>
      {middle}
      <Link to="/riotball" className="marquee-play-link marquee-riotball-link" data-testid={`marquee-riotball-link-${half}-${i}`}>
        PLAY AL RIOTBALL
      </Link>
      {middle}
      <Link to="/wasteland-radio" className="marquee-play-link marquee-highway-link" data-testid={`marquee-highway-link-${half}-${i}`}>
        PLAY DOLOSWAY
      </Link>
      {middle}
      <Link to="/dolopals" className="marquee-play-link marquee-pals-link" data-testid={`marquee-pals-link-${half}-${i}`}>
        DOLOPALS KIDZONE
      </Link>
      {middle}
      <button
        type="button"
        className="marquee-play-link marquee-shop-link"
        onClick={() => window.__openStore?.()}
        data-testid={`marquee-shop-link-${half}-${i}`}
      >
        SHOP THE DROP
      </button>
      {closing}
    </span>
  ));
}

export function Marquee() {
  return (
    <div className="editorial-marquee" data-testid="editorial-marquee">
      <div className="marquee-track">
        <TickerHalf half="a" />
        <TickerHalf half="b" />
      </div>
    </div>
  );
}
